// extracted by mini-css-extract-plugin
export default {"checkboxWrapper":"TodoCheck_checkboxWrapper__Uh5p3","business":"TodoCheck_business__zH0nM","personal":"TodoCheck_personal__SkM6K"};